import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'

import LoginPage from "./pages/LoginPage";
import MainPage from "./layout/MainPage";

import util from './util'
import bizutil from '@/bizutil';
import dialogutil from './dialogutil';

import '@/assets/iconfonts/iconfont.css'; // 从iconfont网站导出的图标的附带的css
import '@/assets/css/iconfont.css'; // 自定义css，对从iconfont网站导出的图标进行二次调整

Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(VueRouter)

// 定义全局路由
const router = new VueRouter({
  routes: [
    { path: "/login", component: LoginPage },
    { path: "/*", component: MainPage },
  ]
});

// 为router定义前置守卫
router.beforeEach((to, from, next) => {
  // 如果目标页面不是登录页，则需要确保已登录，否则自动跳转到登录页
  if (to.path != "/login") {
    let loginUser = util.getFromLocalStorage("loginUser");
    if (!loginUser || loginUser.isLogin != "1") {
      util.gotoLoginPage(router);
    }
  }

  next();
})

// 将全局router存下来，方便用
util.saveGlobalRouter(router);

const store = new Vuex.Store({})

dialogutil.saveGlobalStore(store)

Vue.prototype.$util = util
Vue.prototype.$dialogutil = dialogutil
Vue.prototype.$bizutil = bizutil

new Vue({
  el: '#app',
  render: h => h(App),
  router: router,
  store: store,
})
